import { UserRoleType } from '@/services/users/users.types';
import { get } from 'lodash';
import { AppSection, AppSectionCode, AppSubSection, SectionsDico } from './app-sections.types';

class AppSectionsService {
  private allSections = {
    [AppSectionCode.ADMIN]: {
      public: true,
      code: AppSectionCode.ADMIN,
      name: 'Admin',
      access: [UserRoleType.ADMIN],
      icon: 'fas fa-lock'
    },
    [AppSectionCode.ANALYTICS]: {
      public: true,
      code: AppSectionCode.ANALYTICS,
      name: 'Analyses',
      access: [UserRoleType.ANALYTICS_ACCESS],
      icon: 'fas fa-chart-pie',
      subSections: []
    },
    [AppSectionCode.MANAGEMENT]: {
      public: true,
      code: AppSectionCode.MANAGEMENT,
      name: 'Gestion',
      access: [
        UserRoleType.MANAGEMENT_MAJ_ALGO_COST,
        UserRoleType.MANAGEMENT_MAJ_REPAIR_COST,
        UserRoleType.MANAGEMENT_MASS_STATUS_CHANGE,
        UserRoleType.MANAGEMENT_MAJ_INVOICES
      ],
      icon: 'fas fa-cogs'
    },
    [AppSectionCode.CONTROL]: {
      public: true,
      code: AppSectionCode.CONTROL,
      name: 'Contrôle',
      access: [
        UserRoleType.CONTROL_CONTROL_COMPUTER,
        UserRoleType.CONTROL_MANAGEMENT,
        UserRoleType.CONTROL_GRADING,
        UserRoleType.CONTROL_UNPACKING,
        UserRoleType.CONTROL_WARRANTY_NC
      ],
      stockName: 'control',
      icon: 'fas fa-search',
      subSections: [
        {
          code: 'new',
          name: 'Test de l’ordinateur'
        },
        {
          code: 'form',
          name: 'Ajout d’informations complémentaires'
        },
        {
          code: 'confirm',
          name: 'Impression de l’étiquette'
        }
      ]
    },
    [AppSectionCode.MATCHING]: {
      public: true,
      code: AppSectionCode.MATCHING,
      name: 'Association',
      access: [],
      // excludeAccess: [UserRoleType.BUYBACK_KYPSELI],
      stockName: 'match',
      icon: 'fas fa-cubes',
      subSections: [
        {
          code: 'start',
          name: 'Démarrage du picking'
        },
        {
          code: 'retrieval',
          name: 'Picking en cours'
        },
        {
          code: 'summary',
          name: 'Résumé du picking'
        }
      ]
    },
    [AppSectionCode.PRODUCTION]: {
      public: true,
      code: AppSectionCode.PRODUCTION,
      name: 'Production',
      access: [
        UserRoleType.PRODUCTION_REPAIR,
        UserRoleType.PRODUCTION_KEY_CHANGE,
        UserRoleType.PRODUCTION_QUALITY_CONTROL,
        UserRoleType.PRODUCTION_CLEANING,
        UserRoleType.PRODUCTION_PACKAGING,
        UserRoleType.PRODUCTION_CAGE_MANAGEMENT,
        UserRoleType.PRODUCTION_MANAGEMENT
      ],
      icon: 'fas fa-wrench',
      subSections: []
    },
    [AppSectionCode.PURCHASE]: {
      public: true,
      code: AppSectionCode.PURCHASE,
      name: 'Achats',
      access: [UserRoleType.PURCHASE_RECEPTION, UserRoleType.PURCHASE_ORDER, UserRoleType.PURCHASE_SUPPLIER],
      icon: 'fas fa-shopping-basket',
      subSections: [
        {
          code: 'purchase-stocks',
          name: 'Stocks',
          icon: 'fas fa-barcode',
          public: true,
          access: []
        },
        {
          code: 'purchase-orders',
          name: 'Commandes',
          icon: 'fas fa-shopping-cart',
          public: true,
          access: [UserRoleType.PURCHASE_ORDER]
        },
        {
          code: 'purchase-receptions',
          name: 'Réception',
          icon: 'fas fa-parachute-box',
          public: true,
          access: [UserRoleType.PURCHASE_RECEPTION]
        },
        {
          code: 'purchase-suppliers',
          name: 'Fournisseurs',
          icon: 'fas fa-address-book',
          public: true,
          access: [UserRoleType.PURCHASE_SUPPLIER]
        }
      ]
    },
    [AppSectionCode.ADV]: {
      public: true,
      code: AppSectionCode.ADV,
      name: 'eComm',
      access: [UserRoleType.ADV_ACCESS],
      icon: 'fas fa-comment-dollar',
      subSections: []
    },
    [AppSectionCode.SAV]: {
      public: true,
      code: AppSectionCode.SAV,
      name: 'SAV / RC',
      access: [UserRoleType.SAV_RC_ACCESS],
      icon: 'fas fa-arrow-down',
      subSections: [
        {
          code: 'payment-links',
          name: 'Liens de paiement',
          icon: 'fas fa-link',
          public: true,
          access: [UserRoleType.SAV_RC_ACCESS]
        }
      ]
    },
    [AppSectionCode.SPECIAL_PROCESS]: {
      public: true,
      code: AppSectionCode.SPECIAL_PROCESS,
      name: 'Procédés Spéciaux',
      access: [
        UserRoleType.SPECIAL_PROCESS_ELIGIBILITY_TABLE,
        UserRoleType.SPECIAL_PROCESS_DISMANTLE,
        UserRoleType.SPECIAL_PROCESS_ASSEMBLE
      ],
      icon: 'fas fa-tools',
      subSections: []
    },
    [AppSectionCode.ACCOUNTING]: {
      public: true,
      code: AppSectionCode.ACCOUNTING,
      name: 'Compta.',
      access: [UserRoleType.ACCOUNTING_MEMBER],
      icon: 'fas fa-calculator',
      subSections: []
    },
    [AppSectionCode.BUYBACK]: {
      public: true,
      code: AppSectionCode.BUYBACK,
      name: 'Buyback',
      access: [
        UserRoleType.BUYBACK_ACCESS,
        UserRoleType.BUYBACK_KYPSELI,
        UserRoleType.BUYBACK_RECEPTION,
        UserRoleType.BUYBACK_EXPEDITION,
        UserRoleType.BUYBACK_CONTROL,
        UserRoleType.BUYBACK_ACHAT,
        UserRoleType.BUYBACK_ADMIN
      ],
      icon: 'fas fa-recycle',
      subSections: []
    },
    [AppSectionCode.CRM]: {
      public: true,
      code: AppSectionCode.CRM,
      name: 'CRM',
      access: [UserRoleType.CRM_USER, UserRoleType.ADMIN],
      icon: 'fas fa-address-card',
      subSections: []
    }
  };

  get sections(): AppSection[] {
    return Object.keys(this.allSections)
      .filter(code => !!this.allSections[code].public)
      .map(code => this.allSections[code]);
  }

  traverseSections(code: string, sections: AppSection[] | AppSubSection[], pastTree: string[] = []): string[] {
    let newTree = null;
    sections.forEach(section => {
      if (section.code === code) newTree = [...pastTree, code];
      else if (section.subSections?.length > 0) {
        const tree = this.traverseSections(code, section.subSections, [...pastTree, section.code]);
        if (tree) newTree = tree;
      }
    });
    return newTree;
  }

  createSectionsDico(sections, dico: SectionsDico = {}): SectionsDico {
    sections.forEach(section => {
      dico[section.code] = section;
      if (section.subSections) this.createSectionsDico(section.subSections, dico);
    });
    return dico;
  }

  navBackRoute(value: string, scan = false): string {
    const segments = value.substring(1).split('/');
    switch (segments[0]) {
      case AppSectionCode.SPECIAL_PROCESS:
        if (!segments[1]) return '/';
        return '/specialprocess';
      case AppSectionCode.CONTROL:
        switch (segments[1]) {
          case 'process':
          case 'table':
            return '/control';
          case 'grading':
            return scan ? '/control/grading/scan' : '/control';
          case 'rma':
            return scan ? '/control/rma/scan' : '/control';
          default:
            return '/';
        }
      case AppSectionCode.MATCHING:
        switch (segments[2]) {
          case 'devices':
          case 'order-lines':
            return '/matching';
          default:
            return '/';
        }
      case AppSectionCode.PRODUCTION:
        if (!segments[1]) return '/';
        return '/production';
      case AppSectionCode.PREPARATION:
        if (!segments[1]) return '/';
        else return scan ? '/prepare/process/scan' : '/prepare';
      case AppSectionCode.EXPEDITION:
        if (!segments[1]) return '/';
        else return scan ? '/dispatch/dispatch-process/scan' : '/dispatch';
      case AppSectionCode.PURCHASE:
        return '/';
      case AppSectionCode.ADV:
        if (!segments[1]) return '/';
        return '/adv';
      case AppSectionCode.SAV:
        if (!segments[1]) return '/';
        return '/sav';
      case AppSectionCode.REPAIR:
        if (!segments[1]) return '/';
        else return scan ? '/repair/process/scan' : '/repair';
      case AppSectionCode.ACCOUNTING:
        if (!segments[1]) return '/';
        return '/accounting';
      case AppSectionCode.MANAGEMENT:
        if (!segments[1]) return '/';
        return '/management';
      case AppSectionCode.ANALYTICS:
        if (!segments[1]) return '/';
        return '/analytics';
      default:
        return '/';
    }
  }

  lastIsScan(value: string): boolean {
    const segments = value.substring(1).split('/');
    const regex = /^-?\d+(\.\d+)?$/;

    return regex.test(segments.pop());
  }

  getSubSectionsOf(section: AppSectionCode): AppSubSection[] {
    return get(this.allSections, `${section}.subSections`, []);
  }

  isSubSectionOf(section: AppSectionCode, subSection: string): boolean {
    return !!this.getSubSectionsOf(section).find(s => s.code === subSection);
  }
}

export const appSectionsService = new AppSectionsService();
